import React from 'react'
import { images } from '../../assets/images'
import DashboardWidget from '../../components/common/DashboardWidget/DashboardWidget'
import { useDispatch, useSelector } from 'react-redux'
import { fetchOrganizersThunk } from '../../store/organizer/thunks'
import { RootState } from '../../store/rootReducer'
import { AppDispatch } from '../../store/store'
import { getOrganizerProfile } from '../../api'
import { useState } from 'react'
import { PulseLoader } from 'react-spinners';
import { getOrganizerCurrency } from '../../utils/currency';


type Props = {}

const HomePage = (props: Props) => {
  const currencySymbol = getOrganizerCurrency().symbol;
  const dispatch: AppDispatch = useDispatch();
  const { organizers, loading, error } = useSelector((state: RootState) => state.organizer);
  const [isLoading, setIsLoading] = useState(true); 
  const [organizer, setOrganizer] = useState({ 
      name: '', 
      email: '', 
      profilePic: '' as string | undefined
    });  
  useSelector((state: any) => state)
  // React.useEffect(() => {
  //   dispatch(fetchOrganizersThunk());
  // }, [dispatch])
   React.useEffect(() => {
    dispatch(fetchOrganizersThunk());

      const fetchData = async () => {
        try {
          setIsLoading(true);
          const authUser = localStorage.getItem("authUser");
          if (authUser) {
            const parsedUser = JSON.parse(authUser);
            const userRole = String(parsedUser.user?.userRole);
            if (userRole === "2" || userRole === "8" || userRole === "10") {
              const response = await getOrganizerProfile();
              console.log("Organizer Data:", response);
              setOrganizer({
                name: response.name,  
                email: response.email,
                profilePic: response.profilePic, 
              });
              localStorage.setItem("organizerData", JSON.stringify(response));
            }
          }
          const eventData = localStorage.getItem("eventData");
          if (eventData) {
            const response = await getOrganizerProfile();
            setOrganizer({
              name: response.name,  
              email: response.email ,
              profilePic: response.profilePic, 
            });
            localStorage.setItem("organizerData", JSON.stringify(response));
          }
        } catch (error) {
          console.error("Error fetching organizer profile:", error);
        }finally {
          setIsLoading(false); 
        }
      };
  
      fetchData();
    }, [dispatch]);
  

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-main-title">
          <h3>
            <i className="fa-solid fa-gauge me-3"></i>Dashboard
          </h3>
        </div>
        <div className="col-md-12">
          <div className="main-card add-organisation-card p-4 mt-5">
          {isLoading ? (
        <div className="d-flex justify-content-center py-4">
          <PulseLoader 
            color="#ffffff"  
            size={5}      
            speedMultiplier={.6} 
          />
        </div>
      ) : (
              <div className="ocard-left">
                <div className="ocard-avatar d-flex align-items-center justify-content-center">
                  {organizer.profilePic ? (
                    <img src={organizer.profilePic} alt="" />
                  ) : (
                    <i className="fa-solid fa-user text-danger" style={{ fontSize: '24px' }}></i>
                  )}
                </div>
                <div className="ocard-name">
                  <h4>{organizer.name}</h4>
                  <span>{organizer.email}</span>
                </div>
              </div>
            )}
            {/* <div className="ocard-right">
								<button className="pe-4 ps-4 co-main-btn min-width" data-bs-toggle="modal" data-bs-target="#addorganisationModal"><i className="fa-solid fa-plus"></i>Add Organisation</button>
							</div> */}
          </div>
          <div className="main-card mt-2">
            <div className="dashboard-wrap-content">
              <div className="dashboard-report-content">
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Events"
                      subTitle="12"
                      cardClass="purple"
                      icon="fa-calendar-days"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Revenue"
                      subTitle={`${currencySymbol} 1200`}
                      cardClass="red"
                      icon="fa-credit-card"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Tickets"
                      subTitle="120"
                      cardClass="info"
                      icon="fa-ticket"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Attendees"
                      subTitle="1200"
                      cardClass="success"
                      icon="fa-user"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage